import type { Journey } from '../features/journey/domain/models/journey'

/**
 * Verifica se uma jornada está ativa (não finalizada)
 * Status: 0 = Abierta (ativa), 1 = Cerrada (finalizada)
 * @param journey - Objeto da jornada a ser verificada
 * @returns true se a jornada está ativa, false se finalizada ou null
 */
export const isJourneyActive = (journey: Journey | null): boolean => {
  if (!journey) return false
  
  // Status 0 = Abierta (ativa), Status 1 = Cerrada (finalizada)
  return journey.status === 0
}

/**
 * Obtém o texto do status da jornada
 * @param status - Status numérico da jornada
 * @returns string com o status em texto
 */
export const getJourneyStatusText = (status: number): string => {
  switch (status) {
    case 0:
      return 'Abierta'
    case 1:
      return 'Cerrada'
    default:
      return 'Desconocido'
  }
}